import { render, staticRenderFns } from "./input-mensagem-erro.vue?vue&type=template&id=4a838028&"
import script from "./input-mensagem-erro.vue?vue&type=script&lang=js&"
export * from "./input-mensagem-erro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports